<!-- The mask carries the z-index that lifts this above the global busy overlay
     (primeng.scss): a lapsed session can leave the spinner up, and the shared dialog
     layer would render the only way out underneath it. -->
<p-dialog
  maskStyleClass="session-expired-mask"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="false"
  [modal]="true"
  [(visible)]="visible">

  <ng-template #header>
    <span>{{ (recovery ? 'Trouble signing in' : 'Session expired') | translate }}</span>
  </ng-template>

  @if (recovery) {
    <div>{{ 'We couldn’t sign you back in. Starting over usually fixes it — you’ll be taken to the sign-in page.' | translate }}</div>
  } @else {
    <div>{{ 'Your session has expired. Sign in to continue.' | translate }}</div>
  }

  <ng-template #footer>
    @if (recovery) {
      <a
        href="https://help.miradishare.org/hc/en-us/requests/new"
        target="_blank">
        {{ 'Contact support' | translate }}
      </a>

      <p-button
        icon="fas fa-sync-alt"
        [label]="'Start over' | translate"
        (click)="reset()"
        [raised]="true"
        severity="primary">
      </p-button>
    } @else {
      <p-button
        icon="fas fa-sign-in-alt"
        [label]="'Sign in' | translate"
        (click)="signIn()"
        [raised]="true"
        severity="primary">
      </p-button>
    }
  </ng-template>
</p-dialog>
